import Vue from 'vue'
import Vuex from 'vuex'

import general from './store/general'
import user from './store/user'
import surveys from './store/surveys'
import results from './store/results'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    general,
    user,
    surveys,
    results
  },
  strict: process.env.NODE_ENV !== 'production'
})
